export default __webpack_public_path__ + "static/media/A_Forms.012e3995.png";